/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { StyledBox } from "./styles";

export const ActionContainer = ({ children, sx }) => {
  return <StyledBox sx={sx}>{children}</StyledBox>;
};
